import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-group relative entity-selector offer-selector" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Offers", -1)
const _hoisted_3 = { class: "form-group relative d-flex flex-row align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-expand" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.mdl,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mdl) = $event)),
        multiple: _ctx.multiple,
        filterable: "",
        remote: "",
        "reserve-keyword": "",
        clearable: "",
        "value-key": "v",
        "collapse-tags": "",
        placeholder: "Select",
        "remote-method": _ctx.search,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (o) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: o.v,
              label: o.t,
              value: o.v
            }, null, 8, ["label", "value"]))
          }), 128)),
          _hoisted_4
        ]),
        _: 1
      }, 8, ["modelValue", "multiple", "remote-method", "loading"])
    ]),
    _createElementVNode("div", {
      class: "clear-selector",
      onClick: _cache[1] || (_cache[1] = () => {_ctx.mdl = []})
    }, "Clear")
  ]))
}